import React from 'react'
import { Page, Document, StyleSheet, Image} from '@react-pdf/renderer';
import InvoiceItemsTable from './pdf/InvoiceItemsTable';
import InvoiceTitle from './pdf/InvoiceTitle';
import Sign from './pdf/sign';
import moment from 'moment';
import 'moment/locale/es';

function getRealAge(dateString) {
    
    if(!dateString || dateString == null) {
        return "";
    }
var starts = moment(dateString);
var ends   = moment();
var duration = moment.duration(ends.diff(starts));

return duration.years() + " años "+ duration.months()  +" meses";
}

export default function HistoryTherapyPDF(props) {
    const styles = StyleSheet.create({
        page: {
            fontFamily: 'Helvetica',
            fontSize: 11,
            paddingTop: 30,
            paddingLeft:60,
            paddingRight:60,
            lineHeight: 1.5,
            flexDirection: 'column',
        }, 
        logo: {
            width: '100%',
            height: 'auto',
        }
      }); 

     const personalInfo = [
     {
        id: 1,
        key: "NOMBRE:",
        value: props.affiliateInfo.patient.firstName + " "  +
            `${props.affiliateInfo.patient.secondName || ''}` + " "  +
             props.affiliateInfo.patient.lastName + " "  +
            `${props.affiliateInfo.patient.secondLastName || ''}` 
     },
     {
        id: 2,
        key: "TIPO IDENTIFICACIÓN:",
        value: props.affiliateInfo.patient.typeId
    },
     {
         id: 3,
         key: "IDENTIFICACIÓN:",
         value: props.affiliateInfo.patient.id
     },
     {
         id: 4,
         key: "EPS:",
         value: props.affiliateInfo.patient.eps
     },
     {
        id: 5,
        key: "REGIMEN:",
        value: props.affiliateInfo.patient.regimen
    },
     {
         id: 6,
         key: "EDAD:",
         value: getRealAge(props.affiliateInfo.patient.birthday) 
     },
    
     {
         id: 6,
         key: "TELEFONO:",
         value: props.affiliateInfo.patient.cellphone
     },
 
     {
         id: 7,
         key: "DIRECCION:",
         value: props.affiliateInfo.patient.address
     },
 
     {
         id: 8,
         key: "MUNICIPIO:",
         value: props.affiliateInfo.patient.residenceCode
     }
    ]

    const consulta = [
        {
            id: 1,
            key: "VALORACION FISICA ( valoracion inicial y/o condicion en la que se encuentra el paciente al momento de cada sesion):",
            value: props.affiliateInfo.evolutions[props.indexEvolution].valoration
        },
        {
            id: 2,
            key: "OBJETIVOS (metas a realizar con cada sesion ):",
            value: props.affiliateInfo.evolutions[props.indexEvolution].objective
        },
        {
            id: 3,
            key: "ACTIVIDAD ( terapia - hora ):",
            value: props.affiliateInfo.evolutions[props.indexEvolution].activity
        },
        {
            id: 4,
            key: "TERAPIA tecnicas manuales(rehabilitar, lesiones corporales) masajes, liberacion miofascial, drenaje linfatico:",
            value:props.affiliateInfo.evolutions[props.indexEvolution].therapy
        },
       
        {
            id: 5,
            key: "CONCLUSION(estado en el que queda en paciente):",
            value: props.affiliateInfo.evolutions[props.indexEvolution].conclusion
        }
    ]
    const consultaSSG = [
        {
            id: 1,
            key: "VALORACION FISICA:",
            value: props.affiliateInfo.evolutions[props.indexEvolution].valoration
        },
        {
            id: 2,
            key: "OBJETIVOS:",
            value: props.affiliateInfo.evolutions[props.indexEvolution].objective
        },
        {
            id: 3,
            key: "ACTIVIDAD:",
            value: props.affiliateInfo.evolutions[props.indexEvolution].activity
        },
        
        {
            id: 5,
            key: "CONCLUSION:",
            value: props.affiliateInfo.evolutions[props.indexEvolution].conclusion
        }
    ]
    let consultafinal = consulta;
    let titleFinal = "CONTROL - TERAPIA"
    if (props.affiliateInfo.type =="SST OCUPACIONAL") {
        consultafinal = consultaSSG
        titleFinal = "Historia clinica ocupacional"
     }
let dateAttend = props.affiliateInfo.evolutions[props.indexEvolution].assessmentDate;
        return (
            <Document title={"HC_" + personalInfo[0].value + "_" + moment(dateAttend).locale('es').format('MMMM D YYYY')}>
           
            <Page size="A4" style={styles.page}>

                <Image style={styles.logo} src="https://my-market-mompos-online.s3.amazonaws.com/medisas-resource/logo_pdf_2.png"></Image>
                <InvoiceTitle title={titleFinal} dateAttend={props.affiliateInfo.evolutions[props.indexEvolution].assessmentDate}/>
                <InvoiceItemsTable items={personalInfo} title={"DATOS DE IDENTIFICACION DEL USUARIO"}  separator={2} />
                <InvoiceItemsTable items={consultafinal} title={"Consulta"}  separator={1} />
                <Sign medical={props.affiliateInfo.medicalTeam} patient={props.affiliateInfo.patient} />
            </Page>
          </Document>
        )
    };